import Vue from 'vue'
import Router from 'vue-router'
import listProductPage from '@/components/listProductPage'
import listProductIntroPage from '@/components/listProductIntroPage'
import logIn from '@/components/logIn'
import home from '@/components/home'
import contactUs from '@/components/contactUs'
import product from '@/components/product'
import popularProduct from '@/components/categories/popularProduct'
import otherProduct from '@/components/categories/otherProduct'
import beddingsProduct from '@/components/categories/beddingsProduct'
import cradlesProduct from '@/components/categories/cradlesProduct'
import racksProduct from '@/components/categories/racksProduct'
import shelvesProduct from '@/components/categories/shelvesProduct'
import tableSandSeatsProduct from '@/components/categories/tableSandSeatsProduct'
import woodProduct from '@/components/categories/woodProduct'
import aboutUs from '@/components/aboutUs'
import firebase from 'firebase'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.use(Router)
Vue.use(Vuetify)

// const router = new Router({ routes: routes,  mode: 'history'} )

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      name: 'home',
      component: home
    },
    {
      path: '/home',
      name: 'homePage',
      component: home
    },
    {
      path: '/list-product',
      name: 'listProductPage',
      component: listProductPage,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/list-product-intro',
      name: 'listProductIntroPage',
      component: listProductIntroPage,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/log-in',
      name: 'logIn',
      component: logIn
    },
    {
      path: '/contact-us',
      name: 'contactUs',
      component: contactUs
    },
    {
      path: '/product',
      name: 'product',
      component: product
    },
    {
      path: '/about-us',
      name: 'aboutUs',
      component: aboutUs
    },
    {
      path: '/product/popular',
      name: 'popularProduct',
      component: popularProduct
    },
    {
      path: '/product/table-sand-seats',
      name: 'tableSandSeatsProduct',
      component: tableSandSeatsProduct
    },
    {
      path: '/product/wood',
      name: 'woodProduct',
      component: woodProduct
    },
    {
      path: '/product/shelves',
      name: 'shelvesProduct',
      component: shelvesProduct
    },
    {
      path: '/product/racks',
      name: 'racksProduct',
      component: racksProduct
    },
    {
      path: '/product/cradles',
      name: 'cradlesProduct',
      component: cradlesProduct
    },
    {
      path: '/product/beddings',
      name: 'beddingsProduct',
      component: beddingsProduct
    },
    {
      path: '/product/other',
      name: 'otherProduct',
      component: otherProduct
    }
  ]
})
router.beforeEach((to, from, next) => {
  let currentUser = firebase.auth().currentUser
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  let checkPath = to.matched[0].path
  if (requiresAuth && !currentUser) {
    next('/log-in')
  } else if (!requiresAuth && currentUser) {
    // if user already log in, they cannot go to the log in page
    if (checkPath === '/log-in') {
      alert('you already log in')
      next('/list-product')
    } else {
      // answer game question why it is alway logout
      // firebase.auth().signOut()
      next()
    }
  } else {
    next()
  }
  // bug when log-in and go to log-in page
  // } else if (!requiresAuth && currentUser) {
  //   console.log('22222!requiresAuth && currentUser')
  //   next('/log-in')
  // }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js